import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Sidebar.css";
import { useNavigate } from "react-router-dom";

import useAuthStore from "../../services/authStore";
export default function Sidebar({ setSidebarOpen }) {
  const [authOpen, setAuthOpen] = useState(false);
  const [requestOpen, setRequestOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const location = useLocation();
  const requestCounts = useAuthStore((state) => state.requestCounts);
  const authCounts = useAuthStore((state) => state.authCounts);
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname.startsWith("/requests")) {
      setRequestOpen(true);
    }
  }, [location.pathname]);
  const closeSidebarMobile = () => {
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  };
  const role = useAuthStore((state) => state.role);

  const handleAdminClick = () => {
    setAdminOpen(false);
  };

  const menuClass = "sidebar-section-header hoverable";
  const subMenuClass = ({ isActive }) =>
    `hoverable ${isActive ? "active" : ""}`;

  return (
    <div className="sidebar">
      <div className="sidebar-top-action mobile-only">
        <button
          className="sidebar-new-expense-btn"
          onClick={() => navigate("/new-expense")}
        >
          + New Expense
        </button>
      </div>
      <div>
        <div className={menuClass} onClick={() => setRequestOpen(!requestOpen)}>
          <span>My Requests</span>
          {requestOpen ? <FiChevronUp /> : <FiChevronDown />}
        </div>

        {requestOpen && (
          <ul className="sidebar-submenu">
            {["All", "Pending", "Approved", "Rejected", "Withdraw"].map(
              (item) => (
                <li key={item}>
                  <NavLink
                    to={`/requests/${item.toLowerCase()}`}
                    className={subMenuClass}
                    onClick={() => {
                      handleAdminClick();
                      closeSidebarMobile();
                    }}
                  >
                    <span>{item}</span>
                    <span className="count">
                      {requestCounts?.[item.toLowerCase()] ?? 0}
                    </span>
                  </NavLink>
                </li>
              ),
            )}
          </ul>
        )}
      </div>

      <div>
        <div className={menuClass}>
          <span>My Authorisations</span>
          <FiChevronUp />
        </div>

        <ul className="sidebar-submenu">
          {["All", "Pending", "Approved", "Rejected"].map((item) => (
            <li key={item}>
              <NavLink
                to={`/authorisations/${item.toLowerCase()}`}
                className={subMenuClass}
                onClick={() => {
                  handleAdminClick();
                  closeSidebarMobile();
                }}
              >
                <span>{item}</span>
                <span className="count">
                  {authCounts?.[item.toLowerCase()] ?? 0}
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      {/* Admin Section */}
      {role === "admin" && (
        <div>
          <div className={menuClass} onClick={() => setAdminOpen(!adminOpen)}>
            <span>Setting</span>
            {adminOpen ? <FiChevronUp /> : <FiChevronDown />}
          </div>

          {adminOpen && (
            <ul className="sidebar-submenu">
              {[
                { name: "Expense Type", path: "expensetype" },
                { name: "Grade Limit", path: "grade-limit" },
                { name: "Numbering Series", path: "numbering-series" },
                { name: "Master Setting", path: "master-setting" },
                { name: "Cash Limit", path: "cash-limited" },
                { name: "Petty Cash Permission", path: "pt-cash" },
              ].map((item) => (
                <li key={item.path}>
                  <NavLink to={`/${item.path}`} className={subMenuClass}>
                    <span>{item.name}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
